webpackJsonp([87192162464282],{

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic11.d9e39c8b.jpg";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(529);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Frequently Asked Questions | elev8.it'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'FAQ' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Frequently Asked Questions'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'What should I know about your pricing?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We build out our proposals based on specific, individual company needs. We create a budget and timeline and once they\u2019re approved, we stick to them.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Our pricing is all inclusive and we explain everything in advance. There are no unexpected costs and the client always know what she is paying for.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We may offer discounts based on volume or service bundling.'
	                        ),
	                        _react2.default.createElement('span', null)
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'What is your typical process for working with a new customer?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We ask, listen and understand.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We begin each project by gaining a solid understanding of who you are, what you do and why you do it. This helps us create strategic solutions that communicate the right messages and express your unique brand identity.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Once we learn about your business, we brainstorm ideas that we later filter and combine to create a unique, cost-effective solution aimed at solving your specific problem and achieving your stated goal. Be it brand awareness, lead generation, or increased conversion rates, we always stick to the point.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Once our proposal is ready, we explain it in detail, so you, our client, understand how it all will work. We address all your questions and concerns, so you are completely happy with all the steps.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Once the work is commissioned, we periodically do status checks on progress and deadlines to keep you on track. We are a business just like yours. We take our work very seriously and do whatever it takes to make sure your business is well catered to.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'What education and/or training do you have that relates to your work?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We are a small team of individuals that are well trained and educated in their specific field.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We have a couple of full-stack developers, who take care of all our clients\u2019 (and our own) technological needs. They know PHP, Ruby, javascript, MySQL, and lots of other acronyms you\u2019ve probably never heard of, but make the Internet tick.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'We\u2019ve got a few team members with Masters in Marketing, who are very passionate about their work. They live and breathe SEO, PPC, twitter, instagram, and facebook. They would even design your old-school print flyer, if this will help your campaign. They are that passionate.'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Finally, we\u2019ve got a couple of business guys (a CFA and an MBA) that make sure anything we\u2019re doing helps our clients\u2019 business case. They know economics, accounting, operations, you name it. If it\u2019s boring, they cover it and they cover it well.'
	                        ),
	                        _react2.default.createElement('span', null)
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'How did you get started doing this type of work?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Elev8.it started with a laptop and a dream. A couple of us dreamed of having an online platform that would help people figure out which services are good through reviews. Throughout developing that dream we had to learn many hard lessons and meet countless talented people. Although we did not achieve total success with our dream project, we realized that we have now learned everything it takes to take businesses to success online. We started small, helping our friends and acquaintances with their online visibility. As we started getting more and more clients through referrals, we realized that we are good at what we do. Almost 10 years later, we are serving many clients from all around the globe with a small, dedicated team that knows what is good for business.'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'What types of customers have you worked with?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We have worked with restaurants, small construction companies, food & wine retail businesses, service companies, self-employed individuals, Internet entrepreneurs and countless others that do business online. We usually work with small businesses and startups, but have also taken a few more comprehensive projects with bigger clients.'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Describe a recent project you are fond of. How long did it take?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'For the past two years we have worked (and are still working) on an ambitious project for the UK market, which aims to transform the property improvement and management industry. It is an online platform that offers many innovative services backed by technology. We get to develop cutting-edge solutions to deliver something truly transforming for the industry. We are talking voice controlled user actions, experiments with blockchain technology, augmented reality, and technology-enhanced offline services. We love such projects, as they help us take big leaps forward and this ultimately helps our and our clients\u2019 business.'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'What advice would you give a customer looking to hire a provider in your area of work?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Make sure the provider you start working with has a good track record of successful projects for clients with similar needs to yours. You get what you pay for \u2013 be wary of very low or very high prices. A good professional always charges by the hour and will let you know in advance what you receive for the hours you pay them for. Develop a relationship and make sure the professional is a great fit. Good communication is key in everything you do. We would suggest looking for an individual who gives you priority, i.e. calls you back quickly, keeps you informed of the progress, and responds adequately to your needs.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Still have questions? Get in touch with us now. Let\u2019s talk.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#contact', className: 'button next' },
	                        'GET IN TOUCH'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-js-3cd67ebfc5dbfd84472c.js